<template>
  <div data-locator="features">
    <div class="text-body-1 font-weight-bold pb-5 ml-1">
      {{ $t('project.project-settings.ProjectSettingsFeatures.title') }}
    </div>

    <!-- CHECKLIST -->
    <AppCard class="ma-1" data-locator="checklist-settings">
      <p class="mb-4 text--medium text--bold">
        {{ $t('project.project-settings.ProjectSettingsFeatures.checklist.title') }}
      </p>

      <AppCard class="mb-2" data-locator="double-validation">
        <p class="text--small text--bold">
          {{ $t('project.project-settings.ProjectSettingsFeatures.checklist.doubleValidation') }}
        </p>

        <div class="d-flex justify-space-between align-center mt-2">
          <p class="text--small">
            {{ $t('project.project-settings.ProjectSettingsFeatures.checklist.doubleValidationLabel') }}
          </p>
          <v-switch :model-value="enableValidationChecklistItemDeletion"
                    readonly
                    class="mt-n1"
                    hide-details
                    :loading="patchRoomPending"
                    @click="!patchRoomPending && prepareEnableValidationChecklistItemDeletion()"
          >
          </v-switch>
        </div>
      </AppCard>
    </AppCard>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  import AppCard from '@/common/AppCard.vue'
  import { toast } from '@/common/utils/toast'
  import { PATCH_ROOM } from '@/store/modules/room/action_types'
  import { SET_CURRENT_ROOM } from '@/store/modules/room/mutation_types'

  export default {
    name: 'ProjectSettingsFeatures',
    components: { AppCard },
    props: {
      mnemo: {
        type: String,
        required: true,
      },
    },
    computed: {
      ...mapState('room', ['currentRoom', 'patchRoomPending']),
      enableValidationChecklistItemDeletion () {
        return this.currentRoom?.enableValidationChecklistItemDeletion
      },
    },
    methods: {
      ...mapActions('room', [PATCH_ROOM]),
      async prepareEnableValidationChecklistItemDeletion () {
        try {
          await this.PATCH_ROOM({
            mnemo: this.mnemo,
            data: {
              optEnableValidationChecklistItemDeletion: !this.enableValidationChecklistItemDeletion,
            },
          })
          this.currentRoom.enableValidationChecklistItemDeletion = !this.enableValidationChecklistItemDeletion
          this.$store.commit(`room/${SET_CURRENT_ROOM}`, this.currentRoom)

          toast.success(this.$t('project.project-settings.ProjectSettingsFeatures.checklist.setDoubleValidationSuccess'))
        } catch (error) {
          console.error(error)
          toast.error(this.$t('project.project-settings.ProjectSettingsFeatures.checklist.setDoubleValidationError'))
        }
      },
    },
  }
</script>
